// extracted by mini-css-extract-plugin
export default {"badge":"CustomBadge_badge__EjRtK"};